import { ATTRIBUTION, DAY_IN_MS } from '../constants';

/**
 * A captured set with the times it was taken and stops applying.
 */
export function buildRecord({ params, expiryDays, now = Date.now() }) {
  if (!params) return null;
  return { params, capturedAt: now, expiresAt: now + expiryDays * DAY_IN_MS };
}

/**
 * True for a record that has not reached its expiry.
 */
export function isLiveRecord(record, now = Date.now()) {
  return !!record && typeof record.expiresAt === 'number' && record.expiresAt > now;
}

const capturedAtOf = record => (typeof record.capturedAt === 'number' ? record.capturedAt : 0);

/**
 * Chooses between candidate records under the attribution rule: the oldest
 * capture for first touch, the newest for last touch. Records are ordered by
 * `capturedAt`, not by position, because a record read from storage can be
 * newer than this tab's own (another tab captured later, or consent arrived
 * late). Expired and missing records are dropped. On a tie the order given
 * decides: first touch keeps the first candidate, last touch takes the last.
 */
export function pickRecord({ candidates = [], attribution, now = Date.now() }) {
  const live = candidates.filter(record => isLiveRecord(record, now));
  if (!live.length) return null;

  return live.reduce((chosen, record) => {
    if (attribution === ATTRIBUTION.LAST) {
      return capturedAtOf(record) >= capturedAtOf(chosen) ? record : chosen;
    }
    return capturedAtOf(record) < capturedAtOf(chosen) ? record : chosen;
  });
}
